import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DemoIcon from "../../../assets/VideoEditing/icons/video-demo.svg";
import copyApiImage from "../../../assets/VideoEditing/images/video-editing-overview.png";
import APIIcon from "../../../assets/common/icons/integrate-api.svg";
import ConsoleOverviewCards, { OverviewCardType } from "../../../components/Home/Overview/Cards/ConsoleOverviewCards";
import ConsoleOverviewLayout from "../../../components/Home/Overview/Layout/ConsoleOverviewLayout";
import RouterConstants from "../../../constants/RouterConstants";

const VideoEditingOverview = () => {
	const { t } = useTranslation("translation", { keyPrefix: "videoEditing.overview" });
	const cards: OverviewCardType[] = [
		{
			icon: APIIcon,
			title: t("cards.api.title"),
			description: t("cards.api.description"),
			link: RouterConstants.VIDEO_EDITING.API.fullPath,
		},
		{
			icon: DemoIcon,
			title: t("cards.demo.title"),
			description: t("cards.demo.description"),
			link: RouterConstants.VIDEO_EDITING.DEMO.fullPath,
		},
	];

	return (
		<ConsoleOverviewLayout
			copyApiTokenProps={{
				image: copyApiImage,
				description: t("copyApiToken.description"),
			}}
		>
			<ConsoleOverviewCards cards={cards} />
		</ConsoleOverviewLayout>
	);
};

export default observer(VideoEditingOverview);
